<template>
  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAElBMVEVHcEwac+gac+gac+gac+gac+gtu67uAAAABnRSTlMAV+n+gxT6zFvXAAAAlElEQVR4AWKAAyFFQNn0doIwDABQtIUOIGQEJ7AZQfx3/2ksePEgyefl5AnZlrHPeVvimPOxwomC10BBFERBFERBdIEo+ETBA7Xihg4xGixGg6/vStHguxgdTRQvehebPs9ftNE8m148uupe7PA9yhCDHb4Y7JrF4P89QS8CoiAKoiAKrhREQRREQRREV7h+hOXLfACI4EsohCj6BwAAAABJRU5ErkJggg==" />
</template>

<script>
export default {}
</script>

<style>
</style>
